import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "bootstrap/dist/css/bootstrap.min.css";
// Font Awesome wordt nu via CDN geladen in index.html

document.title = (window as any).__APP_CONFIG__?.appName || document.title;

createApp(App).use(router).mount("#app");
